import React from 'react';
import {Snackbar} from 'material-ui'

const MySnackbar = ({snackbarOpen, snackbarMessage}) => (
	<Snackbar
		open={snackbarOpen}
		message={snackbarMessage || ''}
		autoHideDuration={16000}
	/>
)

export default MySnackbar;


// WEBPACK FOOTER //
// ./src/components/MySnackbar.js